import React, { useState } from "react";
import gallery1 from "../../assets/img/bura.webp";
import gallery2 from "../../assets/img/irrig1.jpg";
import gallery3 from "../../assets/img/asals.webp";
import Search from "../../components/Search";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../../features/fetch/fetchSlice";

const items = [
  {
    title: "1,000,000+",
    desc: "Irrigated Land Targeted (Acres)",
  },
  {
    title: "Kes. 240 B ",
    desc: "Annual Agricultural Revenue",
  },

  {
    title: "700K+",
    desc: "Livestock Supported ",
  },
  {
    title: "5M+",
    desc: "People impacted",
  },

  {
    title: "50+",
    desc: "Irrigation Schemes",
  },
];

const gallerryItems = [
  {
    title: "Revamping the Bura Irrigation Scheme",
    subtitle:
      "The Bura Irrigation Scheme, established in the late 1960s with assistance from the World Bank and the Kenyan government, aims to promote agrarian development and improve food security in the arid and semi-arid lands of Kenya. The scheme has expanded from 6,250 acres under irrigated agriculture at its inception to the current 12,000 acres out of a potential of 25,000 acres. Farmers cultivate a variety of crops, including rice, maize, green grams, cowpeas, soybeans, watermelon, cotton, tomatoes, sorghum, and most recently, Komboka rice. Despite challenges, the scheme remains one of Kenya most ambitious agricultural projects",
    svg: "gallery1",
  },
  {
    title: "Solar-Powered Irrigation in Nakwamoru, Kaputir Ward",
    subtitle:
      "In May 2024, Turkana Governor Jeremiah Lomorukai launched a 30-acre model drip irrigation scheme in Nakwamoru, Kaputir Ward. The project features a solar-powered borehole and a 50,000-liter elevated steel tank designed primarily to support horticultural farming. This initiative aims to enhance food security and promote sustainable agriculture in the region.",
    svg: "gallery2",
  },
  {
    title: "Community Water Management in ASALs",
    subtitle:
      "Communities in Kenya’s Arid and Semi-Arid Lands (ASALs) are increasingly taking charge of their water resources through local irrigation management initiatives. These community-led efforts improve water use efficiency, strengthen food security, and foster resilience against climate challenges by promoting sustainable water governance.",
    svg: "gallery3",
  },
];
function IrrrigationInformation() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const url = "api/v2/getFarmers";
  // const { loading, data, count } = useSelector((state) => ({
  //   loading: state.fetch.loading,
  //   data: state.fetch.data[url] || [],
  //   count: state.fetch.count[url] || 0,
  // }));

  const [searchInput, setsearchInput] = useState(null);

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: "api/v2/getFarmers",
        fullName: e.target.value == "" ? null : e.target.value,
      })
    );
  };

  const svgMap = {
    gallery1,
    gallery2,
    gallery3,
  };
  const processedData = gallerryItems?.map((item) => ({
    ...item,
    svg: svgMap[item?.svg],
  }));
  return (
    <div
      className="irigInfo-pic  h-auto w-full mt-[-6rem] z-0 lg:pt-[12.5rem] pt-[10rem] lg:px-[6.25rem] px-3 pb-[6.25rem]"
      style={{ borderRadius: "12.5rem 6.25rem 0 0" }}
    >
      <div className="w-full flex flex-col items-center justify-center text-center">
        <span className="lg:w-[38.4375rem] w-full text-[#050505] font-sora lg:text-[2rem] text-[1.75rem] font-[600] leading-normal">
          Impact on Food Security and Growth
        </span>

        <span className="lg:w-[40rem] w-full  text-[#1A1A1A] font-sora lg:text-[1rem] text-[.85rem] font-[400]">
          This irrigation investments are strengthening food security, boosting
          farm productivity, and creating jobs. Improved water access is helping
          communities adapt to climate challenges while supporting economic
          development. Below are key figures that show the progress made so far.
        </span>
      </div>

      <div className="mt-[5rem] grid lg:grid-cols-5 grid-cols-1 font-[400] font-sora ">
        {items &&
          items?.map((item) => (
            <div className="flex flex-col">
              <div className="text-[#050505] text-[2rem] ">{item?.title}</div>
              <div className="text-[#1A1A1A] text-[.75rem]  mt-[1rem] ">
                {item?.desc}
              </div>
            </div>
          ))}
      </div>

      <div className="w-full items-center justify-center text-center mt-[5rem] flex gap-[.75rem]">
        <div className="lg:w-[60%] w-full bg-white">
          <Search
            searchInput={searchInput}
            handleSearch={handleSearch}
            text={"What are you looking for? "}
          />
        </div>
        <button
          type="button"
          className="px-[4.5625rem] py-[.73rem] rounded-[.375rem] border border-[#D6E1F5] bg-white 
                  text-[#1A1A1A] font-sora text-[.75rem] font-[400]"
        >
          Search
        </button>
      </div>

      {searchInput && (
        <div className="flex items-center justify-center mt-[.75rem]">
          <span
            className="px-[.75rem] py-[.5rem] rounded-[.75rem] bg-white w-auto text-[#424242]
          text-[.75rem] font-sora font-[400] flex items-center gap-[.25rem]"
          >
            <span className="cursor-pointer">{searchInput}</span>
            <span className="cursor-pointer" onClick={() => setsearchInput("")}>
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11"
                height="10"
                viewBox="0 0 11 10"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.28866 1.78879C2.45138 1.62607 2.7152 1.62607 2.87792 1.78879L5.49996 4.41083L8.122 1.78879C8.28472 1.62607 8.54854 1.62607 8.71125 1.78879C8.87397 1.95151 8.87397 2.21532 8.71125 2.37804L6.08921 5.00008L8.71125 7.62212C8.87397 7.78484 8.87397 8.04866 8.71125 8.21138C8.54853 8.37409 8.28472 8.37409 8.122 8.21138L5.49996 5.58934L2.87792 8.21138C2.7152 8.37409 2.45138 8.37409 2.28866 8.21138C2.12595 8.04866 2.12595 7.78484 2.28866 7.62212L4.9107 5.00008L2.28866 2.37804C2.12595 2.21532 2.12595 1.95151 2.28866 1.78879Z"
                  fill="#1A1A1A"
                />
              </svg>
            </span>
          </span>
        </div>
      )}

      <div className="w-full flex flex-col items-center justify-center text-center mt-[5rem]">
        <span className="text-[#050505] font-sora lg:text-[2rem] text-[1.75rem] font-[600] leading-normal">
          Stories & Updates
        </span>
        <span
          style={{ borderRadius: "0rem 0.75rem 0.75rem 0rem" }}
          className="w-[5.5625rem] h-[.25rem] bg-[#D6E1F5]"
        ></span>
        <span className="mt-[.62rem] text-[#1A1A1A] font-sora lg:text-[1rem] text-[.85rem] font-[400] lg:w-[35rem] w-full">
          Stay up to date with progress, innovations, and community stories from
          Kenya’s irrigation projects:
        </span>
      </div>

      <div className="mt-[2rem] grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-[1rem]">
        {processedData?.map((item) => (
          <div
            key={item?.id}
            className="h-[16rem] relative overflow-hidden rounded-[.75rem] w-full"
          >
            <img
              src={item?.svg}
              alt={item?.title}
              className="absolute top-0 left-0 w-full h-full object-cover z-0"
            />
            <div
              className="absolute bottom-[2rem] left-0 right-0 px-[2rem] z-10 p-2"
              style={{
                background: "rgba(0, 0, 0, 0.4)",
              }}
            >
              <span className="text-white font-sora text-[1rem] font-[600]  ">
                {item?.title}
              </span>

              <span
                className="text-white font-sora text-[.875rem] font-[400] block w-full overflow-hidden"
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                }}
              >
                {item?.subtitle}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default IrrrigationInformation;
